// extracted by mini-css-extract-plugin
export default {"tupacGrid":"im-z","tupacHeader":"jm-z","tupacHeader2":"km-z","tupacMenu":"lm-z","tupacMenu2":"mm-z","tupacMain":"nm-z","tupacMain2":"om-z"};